import React from 'react';
import { useTranslation } from 'react-i18next';
import { categoryEmoji, categoryLabel } from '../utils/insights';

export default function ActionItem({ index = 1, insight }) {
  const { t } = useTranslation('tabs');
  if (!insight) return null;
  const verbatimsCount = Array.isArray(insight.verbatims) ? insight.verbatims.length : 0;

  return (
    <div style={styles.row}>
      <div style={styles.numberWrap}>
        <span style={styles.number}>{index}</span>
      </div>
      <div style={styles.body}>
        <div style={styles.titleRow}>
          <span style={styles.emoji} aria-hidden>{categoryEmoji(insight.category)}</span>
          <span style={styles.title}>{insight.titre || categoryLabel(insight.category, t)}</span>
        </div>
        <p style={styles.action}>{insight.action || insight.constat || ''}</p>
        <div style={styles.footer}>
          {verbatimsCount > 0 && (
            <span>{t('insights.verbatim_count', { count: verbatimsCount })}</span>
          )}
          <span>{categoryLabel(insight.category, t)}</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  row: {
    display: 'flex',
    gap: 12,
    paddingTop: 12,
    paddingBottom: 12,
    borderBottom: '1px solid #EDEAE3',
  },
  numberWrap: {
    flexShrink: 0,
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: '#FFF5F0',
    color: '#E8502A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 700,
  },
  number: {
    lineHeight: 1,
  },
  body: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  emoji: {
    fontSize: 14,
    lineHeight: 1,
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    color: '#1A1A1A',
  },
  action: {
    margin: 0,
    fontSize: 13,
    color: '#1A1A1A',
    lineHeight: 1.5,
  },
  footer: {
    display: 'flex',
    gap: 12,
    fontSize: 11,
    color: '#6B6B6B',
    marginTop: 2,
  },
};
